export const parseProfileHash = (hash) => {
  const fragment = hash.startsWith("#") ? hash.slice(1) : hash;
  const [tab = "", query = ""] = fragment.split("?", 2);
  const parameters = new URLSearchParams(query);

  return {
    tab: tab || "user_info",
    refreshCredits: tab === "billing" && parameters.get("refresh") === "true",
  };
};
